import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { FeedScreen } from 'ui/feed/feed-screen'
import {
  CommonStackParamList,
  renderCommonScreens,
} from 'navigation/common-screen'

export type FeedStackParamList = {
  FeedScreen: undefined
} & CommonStackParamList

const Stack = createStackNavigator<FeedStackParamList>()

export const FeedStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name='FeedScreen' component={FeedScreen} />
    {renderCommonScreens(Stack)}
  </Stack.Navigator>
)
